var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreinactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 23.9974C7.86927 23.9974 6.6826 25.1974 6.6826 26.6641C6.6826 28.1307 7.86927 29.3307 9.33594 29.3307C10.8026 29.3307 12.0026 28.1307 12.0026 26.6641C12.0026 25.1974 10.8026 23.9974 9.33594 23.9974ZM1.33594 2.66406V5.33073H4.0026L8.8026 15.4507L7.0026 18.7174C6.78927 19.0907 6.66927 19.5307 6.66927 19.9974C6.66927 21.4641 7.86927 22.6641 9.33594 22.6641H25.3359V19.9974H9.89594C9.70927 19.9974 9.5626 19.8507 9.5626 19.6641L9.6026 19.5041L10.8026 17.3307H20.7359C21.7359 17.3307 22.6159 16.7841 23.0693 15.9574L27.8426 7.30406C27.9493 7.1174 28.0026 6.89073 28.0026 6.66406C28.0026 5.93073 27.4026 5.33073 26.6693 5.33073H6.94927L5.69594 2.66406H1.33594ZM22.6693 23.9974C21.2026 23.9974 20.0159 25.1974 20.0159 26.6641C20.0159 28.1307 21.2026 29.3307 22.6693 29.3307C24.1359 29.3307 25.3359 28.1307 25.3359 26.6641C25.3359 25.1974 24.1359 23.9974 22.6693 23.9974Z",
    fill: "#90205D",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreinactive);
export default __webpack_public_path__ + "static/media/store inactive.6aa46c6f.svg";
export { ForwardRef as ReactComponent };